module.exports = __webpack_public_path__ + "img/payment-secure-lock.8b54a838.svg";